import {nWarn} from '../../../utils/notice'
import {utils} from '../../../components/common/di-ding/utils'

const styles = utils.flexMixin({
  top: {
    alignItems: 'flex-start',
  },
  left: {
    width: '125px',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    margin: '6px 15px 6px 10px',
  },
  addBtn: {
    marginRight: '8px',
    border: '1px solid',
    cursor: 'pointer',
    color: '#97A8BE'
  },
  timePicker: {
    width: '313px',
    marginBottom: '10px'
  }
})

const periodInput = (h, pageType, data) => {
  const addPlanInputBar = () => {
    const {_planTimes} = data
    if (_planTimes.length >= 3) {
      nWarn('不能添加更多了')
      return
    }
    const lastPlanTime = _planTimes[_planTimes.length - 1].time[1]
    _planTimes.push(generatePlanTime(lastPlanTime))
  }
  const onTimePickerChange = (index, newVal) => {
    if (newVal === null && index !== 0) {
      data._planTimes.splice(index, index)
    }
  }
  // noinspection HtmlUnknownAttribute
  return (
    <div style={styles.top}>
      <div style={styles.left}>
        <div style={styles.addBtn} onClick={addPlanInputBar}>
          <i class={'el-icon-plus'} />
        </div>
      </div>
      <div style={styles.right}>
        {data._planTimes.map((it, index) => <el-time-picker style={styles.timePicker}
          popperClass="time-picker-popper" is-range size="mini"
          value-format="HH:mm:ss" format="HH:mm"
          range-separator="至" placeholder="选择时间范围"
          start-placeholder="开始时间" end-placeholder="结束时间"
          value={it.time}
          onInput={v => void (it.time = v)}
          onChange={e => onTimePickerChange(index, e)}
        />)}
      </div>
    </div>
  )
}

export const generatePlanTime = (startTime) => {
  return {
    key: Math.random(),
    time: [startTime || '06:00:00', '23:00:00']
  }
}

export default periodInput
export {
  periodInput
}



// WEBPACK FOOTER //
// ./src/view/AccessCtrl/business-plan/_period-input.js